import { useState } from 'react'

// local imports
import PoolVehicleService from 'service/PoolVehicleService'
import { IPoolVehicleReservation, IPoolVehicleTimeTableList } from 'types/PoolVehicleType'

export default function useSavePoolVehicleReservation(
  reservationInfos: IPoolVehicleTimeTableList[],
  closeAfterSave: () => void
) {
  const [loading, setLoading] = useState(false)

  const poolVehicleId = reservationInfos[0].poolVehicleId
  const resInfos: IPoolVehicleReservation[] = reservationInfos.map((r) => ({
    id: 0,
    reservationStatusId: 0,
    reservationStartTime: r?.reservationStartHour,
    reservationEndTime: r?.reservationEndHour,
  }))

  const resType =
    reservationInfos[0]?.reservationStartHourStr === 'allDay'
      ? { allDayDate: reservationInfos[0]?.reservationStartHour }
      : { reservationList: resInfos }

  const bodyTemplate = { poolVehicleId: poolVehicleId, ...resType }

  const savePoolVehicleReservation = () => {
    setLoading(true)
    PoolVehicleService.savePoolVehicleReservation(bodyTemplate)
      .then((_res) => closeAfterSave())
      .catch((err) => console.log(err))
      .finally(() => setLoading(false))
  }

  return { savePoolVehicleReservation, loading }
}
